import React, { useMemo, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useServerSideTable } from '../../../hooks/useServerSideTable';
import { getPagedSubscribers, deleteSubscriber } from '../../../services/subscriberService';
import { Subscriber } from '../../../types/subscriber';
import { getSubscriberColumns } from './SubscriberColumns';
import Table from '../../../components/common/Table';
import ConfirmDialog from '../../../components/common/ConfirmDialog';
import pageStyles from '../../Page.module.css';
//import sharedStyles from '../../SharedPageStyles.module.css';
interface TableHeaderProps {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
}

// 2. استخدم هذه الواجهة في تعريف المكون
const TableHeader: React.FC<TableHeaderProps> = ({ searchTerm, setSearchTerm }) => {
  return (
    <div style={{ marginBottom: '1rem', maxWidth: '400px' }}>
      <input
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="ابحث في الجدول..."
        style={{ width: '100%', padding: '0.8rem', borderRadius: '6px', border: '1px solid #ccc' }}
      />
    </div>
  );
};
const SubscribersListPage: React.FC = () => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [subscriberToDelete, setSubscriberToDelete] = useState<Subscriber | null>(null);

  const openDeleteDialog = (subscriber: Subscriber) => {
    setSubscriberToDelete(subscriber);
    setIsDeleteDialogOpen(true);
  };

  const closeDeleteDialog = () => {
    setSubscriberToDelete(null);
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    if (!subscriberToDelete) return;
    const promise = deleteSubscriber(subscriberToDelete.id);
    toast.promise(promise, {
      loading: 'جاري حذف المشترك...',
      success: () => {
        closeDeleteDialog();
        refreshData();
        return 'تم حذف المشترك بنجاح!';
      },
      error: (err) => {
        closeDeleteDialog();
        return err.response?.data?.message || 'فشل في حذف المشترك.';
      },
    });
  };

  const columns = useMemo(() => getSubscriberColumns(openDeleteDialog), []);

  const { table, isLoading, Pagination, refreshData, searchTerm, setSearchTerm } = useServerSideTable<Subscriber>({
    columns,
    fetchData: getPagedSubscribers,
  });

  return (
    <div className={pageStyles.pageContainer}>
      <div className={pageStyles.pageHeader}>
        <h1>إدارة المشتركين الجدد</h1>
      </div>
      <div className={pageStyles.pageContent}>
        <TableHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        <Table<Subscriber> table={table} isLoading={isLoading} />
        <Pagination />
      </div>
      <ConfirmDialog
        isOpen={isDeleteDialogOpen}
        title="تأكيد الحذف"
        message={`هل أنت متأكد من رغبتك في حذف المشترك "${subscriberToDelete?.name}"؟`}
        onConfirm={handleDelete}
        onCancel={closeDeleteDialog}
      />
    </div>
  );
};

export default SubscribersListPage;
